export default {
  name: {
    id: 'rm_metal_lead_name',
    defaultMessage: 'Lead',
  },
  smartphoneLabel: {
    id: 'rm_metal_lead_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_lead_what_it_does',
    defaultMessage:
      'Lead was widely used in tin-lead solder to join electronic components for decades. Since 2006, EU restrictions have encouraged lead-free alternatives because of its toxicity. In compliant consumer electronics, lead is generally limited to trace amounts, subject to specific exemptions.',
  },
  extractionText1: {
    id: 'rm_metal_lead_extraction_p1',
    defaultMessage:
      'Lead is mainly extracted from galena, a lead sulphide ore, usually alongside zinc, silver and copper. Mines produce a lead concentrate, which is roasted and sintered to remove sulphur, then smelted with coke and limestone to produce crude lead. The metal is refined to remove impurities such as copper, arsenic, antimony, tin, bismuth, zinc, silver and gold. Lead is also recovered from recycled lead-acid batteries.',
  },
  quickFactText: {
    id: 'rm_metal_lead_quick_fact',
    defaultMessage:
      'Lead is a highly toxic metal with no significant role in modern smartphones, where lead-free solder has largely replaced tin-lead solder. More than two-thirds of refined lead now comes from recycling, making safe collection and processing essential.',
  },
  envSummaryText: {
    id: 'rm_metal_lead_env_summary',
    defaultMessage:
      'Lead mining and smelting generate acid mine drainage, toxic dust, sulphur dioxide, slag and greenhouse-gas emissions. Lead is highly toxic to aquatic life, while poorly controlled mining and recycling can contaminate air, soil and water.',
  },
  envWaterText: {
    id: 'rm_metal_lead_env_water_text',
    defaultMessage:
      'Lead sulphide mining waste can generate acid mine drainage. Smelting and recycling can also release lead into wastewater and surface water. Lead pollution can persist in aquatic environments and harm organisms.',
  },
  envSoilText: {
    id: 'rm_metal_lead_env_soil_text',
    defaultMessage:
      'Mining can remove vegetation and topsoil and generate large volumes of waste rock and tailings. Lead-bearing dust, slag and residues can contaminate soil and enter crops and food chains, particularly where waste is poorly managed.',
  },
  envBiodiversityText: {
    id: 'rm_metal_lead_env_biodiversity_text',
    defaultMessage:
      'Lead is highly toxic to aquatic life. Mine drainage, smelting emissions and poorly managed waste can therefore harm aquatic and terrestrial ecosystems.',
  },
  envClimateText: {
    id: 'rm_metal_lead_env_climate_text',
    defaultMessage:
      'Refined lead production is estimated to generate around 1.31 kg CO2e per kilogram of lead and require approximately 18.5 MJ of primary energy per kilogram. Mining, concentration and smelting are the main sources of these impacts. Secondary lead production generally generates lower emissions than primary production.',
  },
  humanSummaryText: {
    id: 'rm_metal_lead_human_summary',
    defaultMessage:
      'Lead exposure is a major, well-documented cause of neurological and developmental harm, especially in children. Informal lead-acid battery recycling in parts of Africa, South Asia and Latin America can expose workers and nearby communities to toxic lead dust and fumes. Inhalation or ingestion can damage the nervous system, blood, kidneys and reproductive system, with some effects being irreversible.',
  },
  humanHealthText: {
    id: 'rm_metal_lead_human_health_text',
    defaultMessage:
      'Lead is highly toxic. Exposure can cause neurological damage, cognitive deficits, anaemia, endocrine disruption, kidney disease, reproductive harm and developmental effects.Children and developing foetuses are particularly vulnerable to lead’s neurological and reproductive effects. In industrial settings, inhalation of lead dust and fumes is a major exposure route.',
  },
  humanLegalText: {
    id: 'rm_metal_lead_human_legal_text',
    defaultMessage:
      'Lead and several lead compounds are restricted under REACH, the EU’s chemical-safety law. Some are classified as substances of very high concern, while specific uses require authorisation. The Basel Convention also provides guidelines for the environmentally sound management of waste lead-acid batteries.',
  },
  geoSummaryText: {
    id: 'rm_metal_lead_geo_summary',
    defaultMessage:
      'Lead is strategically important because it is widely used in batteries, which account for approximately 84% of global lead consumption. Primary and refined production are concentrated in a small number of countries, especially China. High recycling rates reduce dependence on mined lead, but environmental regulations and disruptions in battery supply chains can still affect markets.',
  },
  geoDugText: {
    id: 'rm_metal_lead_geo_dug_text',
    defaultMessage:
      'In 2024, global lead mine production was approximately 4.3 million tonnes of lead content. China accounted for nearly 45%, followed by Australia at around 9% and the United States at 7%. The top seven mining countries together accounted for over 80% of global mine production.',
  },
  geoProcessedText: {
    id: 'rm_metal_lead_geo_processed_text',
    defaultMessage:
      'Global refined lead production averaged approximately 14.4 million tonnes per year between 2020 and 2024. China accounted for around 50%, followed by the United States and India, with approximately 7% each. South Korea accounted for 5%, Mexico 3%, and the United Kingdom and Germany 2% each. Refined production includes both primary lead and lead recovered from recycled materials.',
  },
  geoLeverageText: {
    id: 'rm_metal_lead_geo_leverage_text',
    defaultMessage:
      'China’s dominant position in both primary and refined lead production gives it influence over global supply and prices. Chinese demand for automotive and storage batteries is a major price driver. Environmental regulations, mine closures, smelter disruptions and changes in battery technology can also affect availability.',
  },
  supplySummaryText: {
    id: 'rm_metal_lead_supply_summary',
    defaultMessage:
      'The supply of refined lead is likely to meet demand in the short term, but it remains exposed to environmental regulations and disruptions. Global refined lead supply exceeded demand by approximately 63,000 tonnes in 2024, and a surplus of around 121,000 tonnes was forecast for 2025. However, production growth may be constrained by stricter environmental rules, particularly in China.',
  },
  supplyReservesText: {
    id: 'rm_metal_lead_supply_reserves_text',
    defaultMessage:
      'Global identified lead resources exceed 2 billion tonnes. Global reserves are estimated at approximately 95 million tonnes of lead, with the largest reserves in Australia, China, Russia, Mexico and Peru. These figures concern geological resources and reserves, not immediately available refined metal.',
  },
  supplyDemandText: {
    id: 'rm_metal_lead_supply_demand_text',
    defaultMessage:
      'Batteries account for approximately 84% of global lead use. Refined lead demand reached around 13.13 million tonnes in 2024 and is expected to continue growing in the medium term, supported by vehicle, replacement and storage batteries. Clean-energy demand for lead is projected to increase by approximately 54% between 2025 and 2050. This includes demand from solar PV and other low-emissions power generation, such as nuclear energy, bioenergy and hydropower.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_lead_recycling_summary',
    defaultMessage:
      'Lead is one of the most recycled commonly used metals. A 99% recycling rate has been reported for lead-acid batteries in the United States, meaning that near-complete recovery can be achieved for this product stream.',
  },
  recyclingInputText: {
    id: 'rm_metal_lead_recycling_input_text',
    defaultMessage:
      'Across all sectors, approximately 67.5% of global refined lead production was supplied by recycled materials in 2024. In the European Union, around 83% of refined lead production was supplied by secondary lead in 2021. These figures concern overall lead supply, not smartphones, and are separate from the 99% recycling rate for lead-acid batteries.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_lead_recycling_outlook_text',
    defaultMessage:
      'Not entirely, although most demand for lead-acid batteries can be covered where effective collection systems are in place. Near-complete battery recycling has been achieved in the United States, but other lead-containing products are more difficult to recover. Recycling remains dependent on collection, regulation and safe processing, and primary lead production is still required to meet total demand.',
  },
  footnote1Text1: {
    id: 'rm_metal_lead_footnote_1_p1',
    defaultMessage:
      'As lead is not covered by the ADEME 2024 study, its environmental, social, geopolitical and supply-risk scores were calculated by Back Market’s Sustainability team using ADEME’s methodology, public sources and AI assistance. These scores carry greater uncertainty. See the Sources tab for the full methodology and references.',
  },
  mine0Region: {
    id: 'rm_metal_lead_mine0_region',
    defaultMessage: 'Rajsamand',
  },
  mine1Region: {
    id: 'rm_metal_lead_mine1_region',
    defaultMessage: 'Mount Isa',
  },
  mine2Region: {
    id: 'rm_metal_lead_mine2_region',
    defaultMessage: 'Uchaly',
  },
  mine3Region: {
    id: 'rm_metal_lead_mine3_region',
    defaultMessage: 'Noatak',
  },
  mine4Region: {
    id: 'rm_metal_lead_mine4_region',
    defaultMessage: 'San Marcos',
  },
} as const
